// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scolipede: PokeData = {
  "id": 545,
  "name": "scolipede",
  "height": 25,
  "weight": 2005,
  "base_experience": 218,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "poison-sting",
    "toxic",
    "agility",
    "screech",
    "defense-curl",
    "protect",
    "rollout",
    "megahorn",
    "baton-pass",
    "pursuit",
    "iron-defense",
    "poison-tail",
    "rock-climb",
    "bug-bite",
    "venoshock",
    "steamroller",
    "venom-drench"
  ],
  "moves": [
    "protect",
    "pursuit",
    "bug-bite",
    "venom-drench",
    "pin-missile",
    "sticky-web",
    "toxic-spikes",
    "pounce",
    "stun-spore",
    "heal-order",
    "poison-powder",
    "string-shot",
    "acid-rain"
  ],
  "evolution_chain": {
    "id": 277,
    "item": null,
    "species": [
      {
        "name": "venipede",
        "order": 544,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whirlipede",
        "order": 545,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 543,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "scolipede",
        "order": 546,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 544,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 159,
    "ability_power": 142
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
